import React from 'react';
import '../../assets/styles/dishesModal.css';
import { useCachedImage } from '../../Hooks/useCachedImage';
import { getFirestore, collection, doc, getDoc, arrayUnion } from 'firebase/firestore';
import { addDoc, setDoc, updateDoc } from '../../api/FirestoreInterceptor';
import { db, auth } from '../../config-firebase/firebase.js';
import { useNavigate, Link } from 'react-router-dom';
import CustomizedPrice from './CustomizedPrice.js';
import { GlobalContext } from '../../GlobalContext';
import { CheckUser } from '../../Helpers/Helpers.js';
import useLocalStorage from '../../Hooks/useLocalStorage.js';

//React variables
const DishesModal = ({ item, setModal }) => {
  const [totalPrice, setTotalPrice] = React.useState(Number(item.price));
  const [currentUser, setCurrentUser] = React.useState('');
  const [disabledSelect, setDisabledSelect] = React.useState(true);
  const global = React.useContext(GlobalContext);
  const [form, setForm] = React.useState({
    //this object is regarding  to all dishes inside of request
    name: item.title,
    id: item.id,
    recipeOpenCloseModal: false,
    finalPrice: Number(item.price),
    finalCost: item.costPriceObj?.cost || 0,
    image: item.image,
    recipe: item.recipe ? item.recipe : {},
    sideDishes: [],
    size: item.CustomizedPrice?.firstLabel || '',
  });

  const [sideDishesListOnScreen, setSideDishesListOnScreen] = React.useState(
    []
  );

  const [radioDisabled, setRadioDisabled] = React.useState(false);
  const [pdv, setPdv] = useLocalStorage('pdv', false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const navigate = useNavigate();

  const cachedImageSrc = useCachedImage(item?.id, item?.image, 'thumb');
  const src = cachedImageSrc || item?.image;

  React.useEffect(() => {
    if (localStorage.hasOwnProperty('userMenu')) {
      const currentUserNew = JSON.parse(localStorage.getItem('userMenu'));

      setCurrentUser(currentUserNew.id);
    }
  }, []);

  React.useEffect(() => {
    setTotalPrice(Number(item.price) || 0);
    setSideDishesListOnScreen([]);
    setRadioDisabled(false);
    setDisabledSelect(true);
    setForm({
      name: item.title,
      id: item.id,
      category: item.category,
      recipeOpenCloseModal: false,
      finalPrice: Number(item.price) || 0,
      finalCost: item.costPriceObj?.cost || 0,
      image: item.image,
      recipe: item.recipe ? item.recipe : {},
      sideDishes: [],
      size: item.CustomizedPrice?.firstLabel || '',
    });
  }, [item]);

  const calculateFinalCost = () => {
    if (
      item &&
      item.costProfitMarginCustomized &&
      item.costProfitMarginCustomized.firstPrice &&
      item.costProfitMarginCustomized.firstPrice.label === ''
    ) {
      setForm((prev) => ({
        ...prev,
        finalCost: item.costPriceObj?.cost || 0,
      }));
    } else {
      if (form.size === '') {
        setForm((prev) => ({
          ...prev,
          finalCost: item.costPriceObj?.cost || 0,
        }));
      }
    }
  };

  React.useEffect(() => {
    setForm((prevForm) => ({
      ...prevForm,
      finalPrice: totalPrice,
      sideDishes: sideDishesListOnScreen,
    }));
  }, [totalPrice, sideDishesListOnScreen]);

  //select side dishes
  const addSelectedMaximumNumberSideDishes = (e) => {
    const id = e.target.value;
    if (id === "") return;
    const selectedItem = item.sideDishesElementList?.[id];
    if (!selectedItem) return;

    if (sideDishesListOnScreen.length >= item.maxLimitSideDishes) {
      return;
    }

    const newSideDish = {
      name: selectedItem.sideDishes,
      price: selectedItem.price,
      portionUsed: selectedItem?.portionUsed || 0,
      portionCost: selectedItem?.portionCost || 0,
      costPerUnit: selectedItem?.costPerUnit || 0,
      idSideDish: selectedItem?.id || 0,
      unit: selectedItem?.unit || 0,
      totalCost: selectedItem?.totalCost || 0,
      totalVolume: selectedItem?.totalVolume || 0,
    };

    const nextList = [...sideDishesListOnScreen, newSideDish];
    setSideDishesListOnScreen(nextList);
    setRadioDisabled(true);

    if (nextList.length >= item.maxLimitSideDishes) {
      setDisabledSelect(false);
    } else {
      setDisabledSelect(true);
    }

    setTotalPrice((prevTotal) => prevTotal + Number(selectedItem.price || 0));

    let previousCost = Number(form.finalCost) || 0;
    let additionCost = Number(selectedItem?.portionCost) || 0;

    additionCost = additionCost > previousCost ? 0 : additionCost;

    const totalCostChange = Number((previousCost + additionCost).toFixed(2));
    setForm((prev) => ({
      ...prev,
      finalCost: Number(totalCostChange).toFixed(2),
    }));

    e.target.value = "";
  };

  //upload price via checkbox
  function handleChange(e, sideDishItem) {
    const additionalPrice = Number(sideDishItem.price) || 0;
    if (e.target.checked) {
      const newSideDish = {
        name: sideDishItem.sideDishes,
        price: sideDishItem.price,
        portionUsed: sideDishItem?.portionUsed || 0,
        portionCost: sideDishItem?.portionCost || 0,
        costPerUnit: sideDishItem?.costPerUnit || 0,
        idSideDish: sideDishItem?.id || 0,
        unit: sideDishItem?.unit || 0,
        totalCost: sideDishItem?.totalCost || 0,
        totalVolume: sideDishItem?.totalVolume || 0,
      };
      const nextList = [...sideDishesListOnScreen, newSideDish];
      setSideDishesListOnScreen(nextList);
      setTotalPrice((prevTotal) => prevTotal + additionalPrice);
      setRadioDisabled(true);
    } else {
      const nextList = sideDishesListOnScreen.filter((s) => s.name !== sideDishItem.sideDishes);
      setSideDishesListOnScreen(nextList);
      setTotalPrice((prevTotal) => Math.max(0, prevTotal - additionalPrice));
      if (nextList.length === 0) {
        setRadioDisabled(false);
      }
    }
  }

  const closeModal = () => {
    setModal(false);
    setSideDishesListOnScreen([]);
    setRadioDisabled(false);
    setDisabledSelect(true);
  };

  async function handleSubmit(event) {
    if (event && event.preventDefault) event.preventDefault();
    if (isSubmitting) return; // evita disparo duplo
    setIsSubmitting(true);

    const isInsideAdmin = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
    const isPdv = isInsideAdmin && Boolean(
      pdv || 
      global.pdvRequest || 
      window.location.pathname.includes('requestlist') || 
      localStorage.getItem('pdv') === 'true'
    );
    const storedUserMenu = localStorage.getItem('userMenu');
    let activeUser = storedUserMenu ? JSON.parse(storedUserMenu).id : currentUser;

    if (isPdv && !activeUser) {
      const currentUid = auth.currentUser?.uid || `legacy_anon_${Date.now()}`;
      const updatedUser = { id: currentUid, name: 'anonimo' };
      localStorage.setItem('userMenu', JSON.stringify(updatedUser));
      activeUser = currentUid;
      setCurrentUser(currentUid);
      global.setAuthorizated(true);
    }

    if (!global.authorizated && !isPdv) {
      CheckLogin();
    }

    if (!activeUser) {
      setModal(false); 
      setIsSubmitting(false);
      return;
    }

    try {
      const userDocRef = doc(db, 'user', activeUser);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        // Se o documento do usuário já existir, atualiza o array request
        const currentRequests = userDocSnap.data().request || [];

        // Acrescente o novo objeto 'form' ao array 'requests'
        currentRequests.push(form);
        console.log('form   ', form);

        // Atualize o documento com o novo array 'requests'
        await updateDoc(userDocRef, {
          request: currentRequests,
        });
      } else {
        // Se o documento do usuário não existir, cria o documento com o array request
        await setDoc(userDocRef, {
          name: 'anonimo',
          request: [form],
        });
      }

      // Atualiza o estado do formulário para o próximo item
      setForm({
        name: item.title,
        id: item.id,
        finalPrice: Number(item.price),
        image: item.image,
        sideDishes: sideDishesListOnScreen,
        category: item.category,
      });

      // Redireciona o usuário para a página de requisições
      setModal(false); // Fecha o modal após sucesso na gravação

      if (!isPdv) {
        console.log('NÃO SOMOS UM PDV no handleSubmit ', isPdv);
        navigate('/request', { state: { isAdminOrigin: false } });
        global.setPdvRequest(false);
      } else {
        console.log(' SOMOS UM PDV no handleSubmit', isPdv);
        global.setPdvRequest(true);
        navigate('/admin/requestlist', { state: { isAdminOrigin: true } });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false); // libera o botão depois que terminar
    }
  }

  async function CheckLogin() {
    const userId = await CheckUser('userMenu', global.isToten);
    navigate(userId);
  }

  function onPriceChange(priceOption) {
    console.log('O que vem do customize price   ', priceOption);
    form.size = priceOption.label;
    form.finalCost = priceOption.cost;

    const currentSidesCost = sideDishesListOnScreen.reduce(
      (acc, s) => acc + (Number(s.price) || 0),
      0
    );
    setTotalPrice(Number(priceOption.price) + currentSidesCost);
  }

  const removeSideDish = (index) => {
    const itemSelected = sideDishesListOnScreen[index];
    if (!itemSelected) return;

    const nameOnScreen = sideDishesListOnScreen.filter((_, i) => i !== index);
    setSideDishesListOnScreen(nameOnScreen);

    let previousCost = Number(form.finalCost) || 0;
    let additionCost = Number(itemSelected?.portionCost) || 0;
    additionCost = additionCost > previousCost ? 0 : additionCost;

    const totalCostChange = Number(Math.max(0, previousCost - additionCost).toFixed(2));
    setForm((prev) => ({
      ...prev,
      finalCost: Number(totalCostChange).toFixed(2),
    }));

    setTotalPrice((prevTotal) => Math.max(0, prevTotal - (Number(itemSelected.price) || 0)));

    if (nameOnScreen.length === 0) {
      setRadioDisabled(false);
    }

    if (nameOnScreen.length < (item.maxLimitSideDishes || 1)) {
      setDisabledSelect(true);
    }
  };

  return (
    <div className="content-modal-dishes">
      <div className="close-btn">
        <button onClick={closeModal}>X</button>
      </div>
      <h1>{item.title}</h1>
      <img src={src} alt="img" />
      <p>{item.comment}</p>
      <h4>Valor: R${totalPrice.toFixed(2)}</h4>
      {item.CustomizedPrice &&
        item.CustomizedPrice.firstPrice !== 0 &&
        item.CustomizedPrice.firstLabel !== '' && (
          <CustomizedPrice
            item={item.CustomizedPrice}
            onPriceChange={onPriceChange}
            radioDisabled={radioDisabled}
          />
        )}
      <form className="my-3" onSubmit={handleSubmit}>
        {item.sideDishesElementList && (
          <>
            {item.sideDishesElementList.length > 0 && (
              <h4 className="label-side-dishes">
                Selecione o seu acompanhamento
              </h4>
            )}
            <div
              className={
                item.maxLimitSideDishes === 0
                  ? 'side-dishes-list'
                  : 'limit-dishes'
              }
            >
              {item.maxLimitSideDishes == 0 ? (
                item.sideDishesElementList.map((sideDishItem, index) => (
                  <div key={index}>
                    <input
                      className="form-check-input"
                      id={`carrossel-${index}`}
                      value={sideDishItem.price}
                      type="checkbox"
                      checked={sideDishesListOnScreen.some((s) => s.name === sideDishItem.sideDishes)}
                      onChange={(e) => handleChange(e, sideDishItem)}
                      disabled={global.hasRawMaterial && sideDishItem.unavailableRawMaterial}
                    />
                    <label 
                      className="form-check-label"
                      htmlFor={`carrossel-${index}`}
                      style={global.hasRawMaterial && sideDishItem.unavailableRawMaterial ? { color: 'red' } : {}}
                    >
                      {sideDishItem.sideDishes}
                      {global.hasRawMaterial && sideDishItem.unavailableRawMaterial && ' (Indisponível)'}
                    </label>
                  </div>
                ))
              ) : (
                <div className="select-limit-sidedishes">
                  {disabledSelect ? (
                    <select
                      id="sideDishesElement"
                      defaultValue=""
                      className="form-select"
                      onChange={addSelectedMaximumNumberSideDishes}
                    >
                      <option value="" disabled>Selecione</option>
                      {item.sideDishesElementList &&
                        item.sideDishesElementList.map((sideDishItem, index) => (
                          <option 
                            key={index} 
                            value={index}
                            disabled={global.hasRawMaterial && sideDishItem.unavailableRawMaterial}
                            style={global.hasRawMaterial && sideDishItem.unavailableRawMaterial ? { color: 'red' } : {}}
                          >
                            {' '}
                            {sideDishItem.sideDishes}
                            {global.hasRawMaterial && sideDishItem.unavailableRawMaterial && ' (Indisponível)'}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <p style={{ fontSize: '0.85rem' }}>
                      O número máximo de acompanhamentos é{' '}
                      {item.maxLimitSideDishes}
                    </p>
                  )}
                </div>
              )}
            </div>
          </>
        )}
        <div className="added-side-dishes">
          {sideDishesListOnScreen &&
            sideDishesListOnScreen.map((item, index) => (
              <div key={index} className="side-dishe">
                <p>{item.name}</p>{' '}
                {Number(item.price) > 0 && (
                  <p>
                    {' '}
                    {Number(item.price).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                )}{' '}
                <button
                  type="button"
                  className="btn-close-side-dishes"
                  onClick={() => removeSideDish(index)}
                >
                  x
                </button>{' '}
              </div>
            ))}
        </div>
        <button
          type="submit"
          className="request-client-modal"
          disabled={global.hasRawMaterial && item.lowAmountRawMaterial}
        >
          {global.hasRawMaterial && item.lowAmountRawMaterial
            ? 'Indisponível'
            : isSubmitting
            ? 'Enviando...'
            : 'Selecionar'}
        </button>
      </form>
    </div>
  );
};
export default DishesModal;
